import React, { useState, useRef, useEffect } from "react";
import "./CircularMenu.css";
import { DeleteOutlined, EditFilled, EyeOutlined, MoreOutlined, SearchOutlined } from "@ant-design/icons";
import magicToolIcon from "../../assests/Images/effect.svg"
import dragIcon from "../../assests/Images/drag.svg"
import downloadIcon from "../../assests/Images/download.svg"


const ActionMenu = ({action,show,edit,drag,fullView,reel}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const icons = [
    { icon: <EyeOutlined style={{ fontSize: "0.8rem",color:"#005cff" }} />, label: "View" ,x:"-80",y:"15",widthStyle:"", action:"view",visible:fullView},
    { icon: <EditFilled style={{ fontSize: "0.8rem",color:"#005cff" }} />, label: "Edit Text" ,x:"-80",y:fullView ? "44" : "15",widthStyle:"50px",action:"edit",visible:!edit},
    { icon: <img src={magicToolIcon} style={{ width: "0.8rem",color:"#005cff" }}/>, label: "Edit Image" ,x:"-80",y:edit ? "15" : !fullView? "44":"73",widthStyle:"60px", action:"effect",visible:!show},
    { icon: <DeleteOutlined style={{ fontSize: "0.8rem",color:"#005cff" }} />, label: "Delete" ,x:"-80",y: (edit && !show) || (!edit && show && !fullView)? "44" : (edit && show && !fullView)? "15" : !fullView && !edit? "73" :edit? "44" : !show? "104" : "73",widthStyle:"",action:"delete",visible:true},
    { icon: <img src={downloadIcon} style={{ width: "0.8rem",color:"#005cff" }}/>, label: "Download" ,x:"-80",y: (edit && !show) || (!edit && show && !fullView)? "73" : (edit && show && !fullView)? "44" : !fullView && !edit? "104" :show? reel ? "73" : "104" : edit? "73" : "133",widthStyle:"",action:"save",visible:true},
  ];

  return (
    <div className="circular-menu-container" ref={menuRef}>
      <div className={`circular-menu ${open ? "open" : ""}`}>
        {icons.map((item, index) => {
          return (
            <>
            {item.visible &&
            <button
              key={index}
              className="menu-item"
              style={{
                fontSize:"10px",
                justifyContent:"center",
                width: open ? "100px" : "1px",
                display: open ? "block" : "none",
                transform: open
                  ? `translate(${item.x}px, ${item.y}px)`
                  : "translate(0, 0)",
                transitionDelay: `${index * 0.05}s`,
              }}
              title={item.label}
              onClick={() => {
                action(item.action);
                setOpen(false); // Close the menu after action
              }}
            >
              {item.icon}
              {open && <span className="menu-label" style={{width:item.widthStyle}}> {item.label}</span>}
            </button>
        }
            </>
          );
        })}
      </div>

      <button className="toggle-button" onClick={() => setOpen(!open)}>
        <MoreOutlined className={`toggle-icon ${open ? "rotate" : ""}`} />
      </button>
    </div>
  );
};

export default ActionMenu;
